import { render, staticRenderFns } from "./addBClassifyCustomer.pug?vue&type=template&id=38008b9f&lang=pug&"
import script from "./addBClassifyCustomer.ts?vue&type=script&lang=ts&"
export * from "./addBClassifyCustomer.ts?vue&type=script&lang=ts&"
import style0 from "./addBClassifyCustomer.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports